import * as Types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [Types.GET_ADMIN_STORES_BEGIN](state) {
    state.adminStoresGetState = API_STATES.REQUEST_PENDING;
  },
  [Types.GET_ADMIN_STORES_SUCCESS](state, stores) {
    state.adminStoresGetError = null;
    state.adminStores = stores.list;
    state.storesCount = stores.count
    state.adminStoresGetState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.GET_ADMIN_STORES_ERROR](state, err) {
    state.adminStoresGetState = API_STATES.REQUEST_ERROR;
    state.adminStoresGetError = err;
  }
};

export default mutations;